import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {ImgButton} from '../../components/core/button'
import {PlusIcon, ServerEmptyContent} from '../../icons'
import text from './text.json'

const EmptyContent = ({addServerResource}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('empty-content-body server-monitoring', {
            dark: isDarkMode
        })}>
            <ServerEmptyContent/>
            <p>{text.content_empty}</p>
            <ImgButton onClick={addServerResource}>
                {text.add_server_monitoring}
                <PlusIcon/>
            </ImgButton>
        </div>
    )
}
export default EmptyContent
